import { render } from "./ActivitatPremisView.vue?vue&type=template&id=5939c4d2&scoped=true"
import script from "./ActivitatPremisView.vue?vue&type=script&lang=js"
export * from "./ActivitatPremisView.vue?vue&type=script&lang=js"

import "./ActivitatPremisView.vue?vue&type=style&index=0&id=5939c4d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5939c4d2"]])

export default __exports__